import BehavioralDiscountTag from 'components/common/BehavioralDiscountTag';
import StatusTag from 'components/common/StatusTag';
import Tag from 'components/icons/Tag';
import { numberToDollarString, trimEmptyCents } from 'helpers/money';
import * as Types from 'utilities/types';

export const BasketLabel = ({ basket, behavioralDiscounts, isTempo }) => {
  const discountText = () => {
    const percent = basket.discount.percent ? `${basket.discount.percent}%` : null;
    const flatDiscount = basket.discount.amountCents ? basket.discount.amountCents : null;
    const freeShippingText = basket.discount.freeShipping ? ' + FREE SHIPPING' : '';

    const discountAmount =
      flatDiscount > 0 ? trimEmptyCents(numberToDollarString(flatDiscount / 100)) : percent;

    return `${discountAmount} OFF${freeShippingText}`;
  };

  return (
    <div className="flex flex-wrap gap-2">
      {behavioralDiscounts.length > 0 && (
        <BehavioralDiscountTag
          isPastBasket={!basket.futureBasket}
          behavioralDiscounts={behavioralDiscounts}
          isTempo={isTempo}
        />
      )}
      {basket.futureBasket && basket.discount && (
        <StatusTag
          backgroundColor={isTempo ? 'bg-tempo-blue-50' : 'bg-green-50'}
          icon={<Tag className="min-h-3 min-w-3" />}
          text={discountText()}
          textColor={isTempo ? 'text-tempo-blue-90' : 'text-green-100'}
        />
      )}
    </div>
  );
};

BasketLabel.propTypes = {
  basket: AirbnbPropTypes.or([Types.basket, Types.barebonesBasket, Types.defaultEmptyBasket]),
  behavioralDiscounts: PropTypes.array,
  isTempo: PropTypes.bool.isRequired,
};

export default BasketLabel;
